import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Slider from "react-slick";

// Components //
import MediaCardLite from "../../molecules/media-card-lite/MediaCardLite";
import MediaCard from "../../molecules/media-card/mediaCard";
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";
import NoContentMessage from "../../molecules/no-content-message/noContentMessage";

// Services //
import { getJobs } from "../../../services/vacante.services";

// Styles //
import "./RecommendedContentPeople.scss";

const RecommendedContentPeople = (props: any) => {
    const contenidoBibliotecas = useStaticQuery(graphql`
    query QUERY_CONTENIDO_PERSONAS {
        bibliotecaPersonas: allContentfulSubcategorias(
            filter: {contentful_id: {eq: "7KHkTe0HcCUf8Xhn7NvwGC"}}
            ) {
                nodes {
                referenciaSubcategorias {
                    titulo
                    slug
                    referenciaSubcategorias {
                    slug
                    referenciaInterna {
                        referenciaContenido {
                        referenciaMultimedia {
                            tituloMultimedia
                            textoIntroductorio
                            tematica
                            categoriaMultimedia
                            imagenPrincipal 
                            {
                                gatsbyImageData(
                                    layout: CONSTRAINED
                                    outputPixelDensities: [0.5, 1, 2]
                                    breakpoints: [320, 768, 1024, 1440]
                                    placeholder: BLURRED
                                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                )
                                description
                            }
                            tituloBoton
                        }
                        }
                    }
                    }
                }
                }
            }
            bibliotecaComunidades: allContentfulSubcategorias(
                filter: {contentful_id: {eq: "2SmuRXdJp2FuOoTdiVoL5D"}}
            ) {
                nodes {
                    referenciaSubcategorias {
                    titulo
                    slug
                    referenciaInterna {
                    referenciaContenido {
                            referenciaMultimedia {
                                tituloMultimedia
                                textoIntroductorio
                                tematica
                                categoriaMultimedia
                                imagenPrincipal 
                                {
                                    gatsbyImageData(
                                        layout: CONSTRAINED
                                        outputPixelDensities: [0.5, 1, 2]
                                        breakpoints: [320, 768, 1024, 1440]
                                        placeholder: BLURRED
                                        sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                    )
                                }
                            }
                        tituloBoton
                        }
                    }
                    }
                }
            }
        eventosPersonas: allContentfulSubcategorias(
            filter: {contentful_id: {eq: "2HMk90OWYIyHhaLBbB3JKg"}}
        ) {
            nodes {
                referenciaSubcategorias {
                    titulo
                    slug
                    referenciaInterna {
                    referenciaContenido {
                        referenciaEventos {
                        titulo
                        tituloEvento
                        lugarEvento
                        horaEvento
                        fechaEvento
                        tituloBoton
                        imagenPrincipal 
                        {
                            gatsbyImageData(
                                layout: CONSTRAINED
                                outputPixelDensities: [0.5, 1, 2]
                                breakpoints: [320, 768, 1024, 1440]
                                placeholder: BLURRED
                                sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                            )
                            description
                        }
                        modoEvento
                        tipoEvento
                        requiereInscripcion
                        }
                    }
                    }
                }
            }
        }
        noContentPersonas: contentfulPlantillaContenido(contentful_id: {eq: "2dt9lXNqjZbN2k5Tkcxk6X"}) {
            tituloBanner
            descripcion {
                raw
            }
            imagenPrincipal 
            {
                gatsbyImageData(
                    layout: CONSTRAINED
                    outputPixelDensities: [0.5, 1, 2]
                    breakpoints: [320, 768, 1024, 1440]
                    placeholder: BLURRED
                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                )
                description
            }
        }
    }
`);

    const eventosPersonasData = contenidoBibliotecas.eventosPersonas.nodes[0].referenciaSubcategorias;
    const personasData = contenidoBibliotecas.bibliotecaPersonas.nodes[0].referenciaSubcategorias;
    const noContentPersonas = contenidoBibliotecas.noContentPersonas;

    const [oportunidadesContent, setOportunidadesContent] = useState([]);
    const [personasContent, setPersonasContent] = useState([]);
    const [sliderNovedades, setSliderNovedades] = useState();
    const [interesContent, setInteresContent] = useState([]);
    const [recommendedData, setRecommendedData] = useState<any[]>([]);
    const [indexNovedades, setIndexNovedades] = useState(0);
    const [sliderIndex, setSliderIndex] = useState(0);
    const [loaded, setLoaded] = useState(true);
    const [slider, setSlider] = useState();

    // Currency settings
    const optionCol = { style: 'currency', currency: 'COP', maximumFractionDigits: 0, };
    const formattedSalary = new Intl.NumberFormat('es-CO', optionCol);

    // Configuracion para el slider De tu interes
    const tendenciasCarousel = {
        className: 'slider-tendencias',
        customPaging: i => (
            <div className={`line line-${i}`}>──</div>
        ),
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        }
    };

    // Configuracion para el slider de Novedades
    const OportunidadesCarousel = {
        className: 'slider-oportunidades',
        customPaging: i => (
            <div className={`line line-${i}`}>──</div>
        ),
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setIndexNovedades(next);
        }
    };

    // Control del index para el slider Interes
    const goToNext = () => {
        if (sliderIndex < slider.props.children.length) {
            setSliderIndex(sliderIndex + 1);
            slider?.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length;

    // Control del index para el slider de Novedades
    const goToNextN = () => {
        if (indexNovedades < sliderNovedades.props.children.length - 1) {
            setIndexNovedades(indexNovedades + 1);
            sliderNovedades.slickNext();
        }
    };

    const goToBackN = () => {
        if (indexNovedades > 0) {
            setIndexNovedades(indexNovedades - 1);
            sliderNovedades.slickPrev();
        }
    };

    const isActiveBackN = () => indexNovedades > 0;
    const isActiveNextN = () => indexNovedades < sliderNovedades?.props.children.length - 1;

    // Funcion para generar un numero aleatorio entre 0 y maxNumber
    const randomNumber = (maxNumber: number) => {
        return Math.floor(Math.random() * maxNumber);
    }

    const setRandomArticle = (library, setLibrary) => {
        // Selecciona una categoria aleatoria de la biblioteca personas del index 0 hasta el index 4
        const category = library[randomNumber(4)]

        // Selecciona un articulo aleatorio de la categoria aleatoria
        const articleSubcategory = category.referenciaSubcategorias[randomNumber(category.referenciaSubcategorias.length)]
        const articleSlug = articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]

        // Slug para la redireccion del boton
        articleSlug["redireccionBoton"] = "/personas/biblioteca/" + category.slug + articleSubcategory.slug
        setLibrary(prevContent => [...prevContent, articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
    }

    const setRandomEvent = () => {
        if(eventosPersonasData && eventosPersonasData.length != 0) {
            const randomEventSubcategory = eventosPersonasData[randomNumber(eventosPersonasData.length)]
            const randomEvent = randomEventSubcategory.referenciaInterna.referenciaContenido[0].referenciaEventos[0]
            randomEvent["redireccionBoton"] = '/personas/eventos/' + randomEventSubcategory.slug
            setOportunidadesContent(prevState => [...prevState, randomEvent])
        } else {
            setOportunidadesContent(prevState => [...prevState, null])
        }
    }

    // Obtener lista de vancantes
    const getVacantes = async (idCity: string | null) => {
        await getJobs(`&city=${idCity}`)
            .then((response) => {
                const { data } = response.data;
                if (data.vacantes.content.length > 0) {
                    setRecommendedData(data.vacantes.content);
                } else {
                    getVacantes("1");
                }
            })
            .catch((err) => {
                console.error("Error get jobs: " + err);
            });
    }

    // Contenido para los bloques de sliders
    useEffect(() => {
        // Contenido para el bloque 1 de slider 'Publicaciones recientes'
        for (let index = 0; index < 4; index++) {
            setRandomArticle(personasData, setPersonasContent)
        }

        // Contenido para el bloque 2 de slider 'Oportunidades para ti'
        for (let index = 0; index < 2; index++) {
            if(index == 0) setRandomEvent()
            // El index de personasData es la posicion de la subcategoria en el CMS de biblioteca personas EntryId: 7KHkTe0HcCUf8Xhn7NvwGC
            // Index 5: Categoria Mas de empleo
            // Index 6: Categoria Iniciativas de empleo
            const article = personasData[index + 5].referenciaSubcategorias[randomNumber(personasData[index + 5].referenciaSubcategorias.length)]
            article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]['redireccionBoton'] = '/personas/biblioteca/' + personasData[index + 5].slug + article.slug
            setOportunidadesContent(prevState => [...prevState, article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
        }
    }, [])

    // Contenido para el bloque 1 de slider 'De tu interes'
    useEffect(() => {
        if (personasContent)
            setInteresContent([personasContent])

        if (personasContent.length > 1 && interesContent.length > 1)
            setLoaded(true)
    }, [personasContent])


    useEffect(() => {
        getVacantes("1");
    }, [])

    return (
        <>
            <div className="o-recommended-content-people" id={"destacadosDeTuInteresPersonas"}>
                <div className="o-recommended-content-people-title">
                    <TitleSection title={"Destacados de tu interés"} />
                </div>

                <div className="o-recommended-content-people-section">
                    <div className="o-recommended-content-people-section-interes">
                        <h3 className="o-recommended-content-people-section-interes-title">
                            Publicaciones<br />recientes
                        </h3>
                        <>
                            <div className="o-recommended-content-people-section-interes-card">
                                <div className="o-recommended-content-people-section-interes-card-arrows-slider">
                                    <span
                                        className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""
                                            } gtm_navegar_recientes_atras_personas`}
                                        onClick={goToBack}
                                    ></span>
                                    <span
                                        className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""
                                            } gtm_navegar_recientes_adelante_personas`}
                                        onClick={goToNext}
                                    ></span>
                                </div>
                                <Slider ref={(c) => { setSlider(c); }}{...tendenciasCarousel}>
                                    {loaded && interesContent.map((cards) => (
                                        cards.map((item, i) => (
                                            <>
                                                <MediaCard
                                                    key={i}
                                                    tituloMultimedia={item.tituloMultimedia}
                                                    descripcion={{
                                                        json: undefined
                                                    }}
                                                    imagenPrincipal={
                                                        item.imagenPrincipal    
                                                    }
                                                    tituloBoton='VER MÁS'
                                                    redireccionBoton={item.redireccionBoton}
                                                    slug={item.redireccionBoton}
                                                    tematica={item.tematica}
                                                    categoriaMultimedia={item.categoriaMultimedia}
                                                    nuevoContenido={false}
                                                    parentContentfulId={props.contentful_id} 
                                                />
                                            </>
                                        ))))}
                                </Slider>
                                <div className="o-recommended-content-people-section-interes-button">
                                    <Button
                                        classname={`a-button primary restricted-content-modal__button__biblioteca`}
                                        type="link"
                                        text="IR A LA BIBLIOTECA"
                                        href={`${props.location.href}biblioteca/`}
                                        isDisabled={false}
                                    />
                                </div>
                            </div>
                        </>
                    </div>

                    <div className="o-recommended-content-people-section-novedades">
                        <h3 className="o-recommended-content-people-section-novedades-title">
                            Oportunidades para ti
                        </h3>
                        <div className="o-recommended-content-people-section-novedades-card-arrows-slider">
                            <span
                                className={`arrow icon-chevron-left ${isActiveBackN() ? "active" : ""
                                    } gtm_navegar_novedades_atras_personas`}
                                onClick={goToBackN}
                            ></span>
                            <span
                                className={`arrow  icon-chevron-right  ${isActiveNextN() ? "active" : ""
                                    } gtm_navegar_novedades_adelante_personas`}
                                onClick={goToNextN}
                            ></span>
                        </div>
                        <Slider ref={(c) => { setSliderNovedades(c); }}{...OportunidadesCarousel}>
                            {loaded && oportunidadesContent.map((item: any, index) => {
                                if(item == null) {
                                    return <NoContentMessage key={index} title={noContentPersonas.tituloBanner} subtitle={noContentPersonas.descripcion} imagenPrincipal={noContentPersonas.imagenPrincipal}className="evento-personas"/>
                                }
                                return <MediaCard
                                    key={item.redireccionBoton}
                                    tituloMultimedia={item.tituloMultimedia || item.tituloEvento}
                                    textoIntroductorio={item.textoIntroductorio}
                                    descripcion={{
                                        json: undefined
                                    }}
                                    imagenPrincipal={
                                        item.imagenPrincipal    
                                    }
                                    tituloBoton={item.requiereInscripcion ? 'INSCRÍBETE AQUÍ' : "CONOCE MÁS AQUÍ"}
                                    redireccionBoton={item.redireccionBoton}
                                    slug={item.redireccionBoton}
                                    tematica={item.tematica}
                                    categoriaMultimedia={item.categoriaMultimedia || item.tipoEvento}
                                    tituloEvento={item.tituloEvento}
                                    fechaEvento={item.fechaEvento?.split(',')[2] + ', ' + item.fechaEvento?.split(',')[0] + ' de ' + item.fechaEvento?.split(',')[1]}
                                    horaEvento={item.horaEvento}
                                    lugarEvento={item.lugarEvento}
                                    nuevoContenido={false}
                                    parentContentfulId={props.contentful_id}
                                />
                            })}
                        </Slider>
                    </div>

                    <div className="o-recommended-content-people-section-ofrecemos">
                        <h3 className="o-recommended-content-people-section-ofrecemos-title">
                            Vacantes destacadas para ti
                        </h3>
                        {recommendedData?.slice(0, 3).map((item) => (
                            <>
                                <MediaCardLite
                                    key={item.referenceNumber}
                                    tituloMultimedia={item.title}
                                    tituloBoton="VER DETALLE"
                                    salario={item.salary ? formattedSalary.format(item.salary) : "Confidencial"}
                                    redireccionBoton={`${props.location.href}vacantes-en-antioquia/vacante/?id=${item.referenceNumber}`}
                                    parentContentfulId={props.contentful_id} 
                                />
                            </>
                        ))}

                        <div className="o-recommended-content-people-section-ofrecemos-button">
                            <Button
                                classname={`a-button primary restricted-content-modal__button gtm_ver_vacantesdestacadosdetuinteres`}
                                type="link"
                                text="VER TODAS LAS VACANTES"
                                href={`${props.location.href}vacantes-en-antioquia/`}
                                isDisabled={false}
                            />
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default RecommendedContentPeople;
